module.exports = __webpack_public_path__ + "img/t_sites.6ea9b758.jpg";